export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-5">关于我们</h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                羞羞歪歪漫画成立于2020年，是国内领先的免费在线漫画阅读平台。我们致力于为广大漫画爱好者提供<strong>免费全集无删减</strong>的高品质漫画内容，覆盖热血、恋爱、搞笑、悬疑、奇幻等全品类题材。平台采用先进的<strong>下拉式阅读</strong>技术，告别传统翻页模式，让您沉浸在流畅的漫画世界中。
              </p>
              <p>
                我们与多家正版漫画平台达成深度合作，每日同步更新最新话，确保读者第一时间看到心仪作品的更新。无论是经典日漫、国漫精品还是小众佳作，羞羞歪歪漫画在线观看入口官网都是您最值得信赖的漫画之家。
              </p>
              <p>
                截至目前，平台已累计收录<strong className="text-primary-600">超过20000部</strong>漫画作品，日均活跃读者超过百万。我们始终坚持免费、无删减、无广告干扰的阅读理念，让每一位漫画爱好者都能享受纯粹的阅读乐趣。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center"><i className="ri-shield-check-line"></i></span>
                <span>内容安全审核</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center"><i className="ri-refresh-line"></i></span>
                <span>每日准时更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-secondary-100 text-secondary-600 flex items-center justify-center"><i className="ri-device-line"></i></span>
                <span>多端同步阅读</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[440px]">
            <div className="grid grid-cols-2 gap-3">
              {[
                { num: '20000+', label: '漫画资源', color: 'text-primary-600' },
                { num: '100万+', label: '日活读者', color: 'text-accent-600' },
                { num: '每日更新', label: '同步连载', color: 'text-secondary-600' },
                { num: '99.9%', label: '可用率', color: 'text-primary-600' },
              ].map((stat) => (
                <div key={stat.label} className="bg-background-100 rounded-xl p-5 text-center">
                  <div className={`text-xl md:text-2xl font-bold ${stat.color} mb-1`}>{stat.num}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}